import { createSlice } from '@reduxjs/toolkit';
import {
  CreateBrand,
  DeleteBrand,
  EditBrandDetail,
  GetAllBrand,
  GetAllMajorBrand,
  GetSingleBrandDetails,
  SearchForBrandsByName,
  UploadBrandIcon,
  UploadBrandImage,
} from './brand_services_sync';

export const brandSlice = createSlice({
  name: 'brand',
  initialState: {
    brand_loader: false,
    allBrandLoader: true,
    brandDeleteLoader: false,
    brandEditLoader: false,
    bndEditLoader: false,
    message: '',
    completeBrand: {},
    completeMajorBrand: [],
    brandDetails: {},
    brandImageDetails: {},
    brandIconDetails: {},
    completeBrandSearch: {},
    brand_page: 0,
    brand_limit: 10,
    editBrandId: '',
  },
  reducers: {
    clearState: (state) => {
      state.brand_loader = false;
      state.message = '';
      state.completeBrand = {};
      state.completeMajorBrand = [];
      state.allBrandLoader = true;
      state.brandDeleteLoader = false;
      state.brandEditLoader = false;
      state.bndEditLoader = false;
      state.brandDetails = {};
      state.completeBrandSearch = {};
      state.brandImageDetails = {};
      state.brandIconDetails = {};
      state.editBrandId = '';

      return state;
    },

    updateBrandDetails: (state, action) => {
      state.brandDetails = action.payload;
    },

    updateCompleteBrand: (state, action) => {
      state.completeBrand = action.payload;
    },
    updateBrandId: (state, { payload }) => {
      state.editBrandId = payload;
    },

    updateBrandImageDetails: (state, { payload }) => {
      state.brandImageDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateBrand.pending, (state) => {
        state.brand_loader = true;
      })
      .addCase(CreateBrand.fulfilled, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
        state.brandImageDetails = {};
      })
      .addCase(CreateBrand.rejected, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
      })
      .addCase(UploadBrandImage.pending, (state) => {
        state.brandEditLoader = true;
      })
      .addCase(UploadBrandImage.fulfilled, (state, { payload }) => {
        state.brandEditLoader = false;
        state.profileMessage = payload.message;
        state.brandImageDetails = payload.data;
      })
      .addCase(UploadBrandImage.rejected, (state, { payload }) => {
        state.brandEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(UploadBrandIcon.pending, (state) => {
        state.brandEditLoader = true;
      })
      .addCase(UploadBrandIcon.fulfilled, (state, { payload }) => {
        state.brandEditLoader = false;
        state.profileMessage = payload.message;
        state.brandIconDetails = payload.data;
      })
      .addCase(UploadBrandIcon.rejected, (state, { payload }) => {
        state.brandEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(GetAllBrand.pending, (state) => {
        state.brand_loader = true;
      })
      .addCase(GetAllBrand.fulfilled, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
        state.completeBrand = payload.data;
        state.brand_page = payload?.data?.page;
      })
      .addCase(GetAllBrand.rejected, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
      })
      .addCase(GetAllMajorBrand.pending, (state) => {
        state.brand_loader = true;
      })
      .addCase(GetAllMajorBrand.fulfilled, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
        state.completeMajorBrand = payload.data;
      })
      .addCase(GetAllMajorBrand.rejected, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
      })
      .addCase(DeleteBrand.pending, (state) => {
        state.brandDeleteLoader = true;
      })
      .addCase(DeleteBrand.fulfilled, (state, { payload }) => {
        const filterData = state.completeBrand?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        state.completeBrand = {
          ...state.completeBrand,
          docs: filterData,
        };

        state.brandDeleteLoader = false;
        state.message = payload.message;

        state.editBrandId = '';
      })
      .addCase(DeleteBrand.rejected, (state, { payload }) => {
        state.brandDeleteLoader = false;
        state.message = payload.message;
        state.editBrandId = '';
      })
      .addCase(GetSingleBrandDetails.pending, (state) => {
        state.brand_loader = true;
      })
      .addCase(GetSingleBrandDetails.fulfilled, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
        state.brandDetails = payload.data;
      })
      .addCase(GetSingleBrandDetails.rejected, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload.message;
      })
      .addCase(EditBrandDetail.pending, (state) => {
        state.bndEditLoader = true;
      })
      .addCase(EditBrandDetail.fulfilled, (state, { payload }) => {
        state.bndEditLoader = false;
        state.message = payload.message;

        state.brandImageDetails = {};
      })
      .addCase(EditBrandDetail.rejected, (state, { payload }) => {
        state.bndEditLoader = false;
        state.message = payload.message;
      })

      .addCase(SearchForBrandsByName.pending, (state) => {
        state.brand_loader = true;
      })
      .addCase(SearchForBrandsByName.fulfilled, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload?.message;

        state.completeBrandSearch = payload?.data;
      })
      .addCase(SearchForBrandsByName.rejected, (state, { payload }) => {
        state.brand_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  updateBrandDetails,
  updateCompleteBrand,
  updateBrandId,
  updateBrandImageDetails,
} = brandSlice.actions;
export const brandSelector = (state) => state.brand;

export default brandSlice.reducer;
